config = require('TENANT_CONFIG').customerApplication;

class ConfigService
  constructor: () ->
    @heapEnabled                    = config.analytics.heap
    @googleTagManagerEnabled        = config.analytics.googleTagManager
    @useAmountModal                 = config.useAmountModal
    @useAmountCleaveForFormatting   = config.useAmountCleaveForFormatting
    @useAmountModalForSessionExpiry = config.useAmountModalForSessionExpiry
    @applicationSubHeader           = config.subheader
    @header                         = config.header
    @sidebar                        = config.sidebar
    @subheader                      = config.subheader
    @viewPrefix                     = "/apply"
    @apiPrefix                      = "/api/customer_applications"
    @completePrefix                 = "/customer/home"
    @logoutUrl                      = "/logout"

  viewBaseUrl: (customer_application_id) ->
    "#{@viewPrefix}/#{customer_application_id}"
  apiBaseUrl: (customer_application_id) ->
    "#{@apiPrefix}/#{customer_application_id}"
  sessionTimeoutCheckUrl: (customer_application_id) ->
    "#{@apiBaseUrl(customer_application_id)}/check_session_timeout"
  restartApplicationUrl: (customer_application_id) ->
    "#{@apiBaseUrl(customer_application_id)}/timeout_session"
  canRestartApplication: true
  renewSessionModalVersion: config.renewSessionPath

angular
.module("avant.services")
.service("ConfigService", ConfigService)

if typeof ApplicationService != 'undefined'
  if typeof exports != 'undefined'
    if typeof module != 'undefined' && module.exports
      exports = module.exports = ApplicationService
    exports.ApplicationService = ApplicationService
  else
    window.ApplicationService = ApplicationService
